export default __webpack_public_path__ + "static/media/markAteer.62ccb3f3.png";